import { useEffect, useState } from "react";
import DropdownMenu from "../../../../shared/components/DropdownMenu.tsx";
import { api } from "../../../../shared/hooks/api";
import { color } from "../../../../shared/styles";

export const PurchasingStaffDropdown = ({ placeholder, onChange, purchasingStaffId, disabled }: any) => {
    const [{ data, isLoading }] = api.get('/users/?role=PURCHASING_STAFF');
    const [selectedItem, setSelectedItem] = useState<{id: string; text: string} | null>(null);

    const items = data ? data.results : [];

    useEffect(() => {
        if (purchasingStaffId) {
            const defaultItem = items.find((item: any) => item.id === purchasingStaffId)
            setSelectedItem(defaultItem ? { id: defaultItem.id, text: defaultItem.display_name ?? defaultItem.username } : null);
        }
    }, [purchasingStaffId, items]);

    return (
        <DropdownMenu
            menuList={items.map((item: any) => ({ id: item.id, text: item.display_name ?? item.username }))}
            menuText={selectedItem ? selectedItem.text : placeholder}
            handleOnclickItem={(item: any) => {
                setSelectedItem(item);
                onChange(item.id);
            }}
            disabled={disabled}
            style={{
                flex: 1,
                width: "100%",
                height: "36px",
                maxWidth: "655px",
                padding: "6px 10px",
                border: `1px solid ${color.emphasis.NEUTRAL_N70}`,
                borderRadius: "5px",
                lineHeight: "24px",
                fontWeight: "400",
                fontSize: "14px",
                appearance: "none",
                color: selectedItem ? "inherit" : color.secondary.DARK_GREY,
            }}
        />
    );
}